// extracted by mini-css-extract-plugin
export default {"SolutionPage":"SolutionPage-module--SolutionPage--33vLj"};